var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconGive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 110,
    viewBox: "0 0 154 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_Give"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M132.812 65.1771C131.244 62.8867 127.664 62.8511 120.618 65.057C118.774 61.7615 115.883 60.0448 105.528 63.6027C105.528 63.6027 103.27 58.9285 97.943 61.3079C94.6784 62.7666 87.9174 66.6047 83.1741 69.3532L94.331 70.3539C98.9541 70.4028 102.673 74.2631 102.482 78.9329C102.29 83.6026 98.4998 86.8136 94.0459 86.8136H67.9196C66.9888 86.8136 66.1604 86.1332 66.0713 85.2081C65.9689 84.1452 66.8017 83.2557 67.8439 83.2557H94.1127C96.549 83.2557 98.6779 81.4545 98.9051 79.0352C99.1678 76.26 97.4398 74.1964 94.2463 73.9118L80.2078 72.6621C78.9696 72.5509 77.7716 72.1728 76.6982 71.5458C73.0861 69.4466 64.5659 64.4744 62.4325 63.0824C59.4395 61.1256 55.0747 58.2614 49.8994 58.0969C41.348 57.8256 33.429 62.273 33.429 62.273L20.0586 68.2414C20.0586 68.2414 31.4248 93.2267 32.6496 95.9219C39.3393 91.3144 44.0069 87.6898 52.4871 93.1022C60.9672 98.5147 72.8233 104.652 77.2905 104.652C81.7578 104.652 86.4165 103.113 89.8103 100.605C93.2041 98.0922 127.267 76.002 131.721 72.4975C134.033 70.683 134.367 67.4586 132.808 65.1816L132.812 65.1771Z",
    fill: "#38A6D5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M103.309 10.3633C96.6104 3.67446 85.743 3.67446 79.0444 10.3633L77.8686 11.5374L76.6928 10.3633C69.9942 3.67446 59.1268 3.67446 52.4282 10.3633C45.7296 17.0522 45.7296 27.9038 52.4282 34.5927L75.3522 57.4833C76.7418 58.8709 78.9999 58.8709 80.3895 57.4833L103.313 34.5927C110.012 27.9038 110.012 17.0522 103.313 10.3633H103.309Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGive);
export default __webpack_public_path__ + "static/media/icon-give.6afc95526713c84fd5c81c3a28b17c97.svg";
export { ForwardRef as ReactComponent };